<script>
import BaseStoreTagList from "./BaseStoreTagList";
export default {
  components: { BaseStoreTagList },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: ''
    },
    orderList: {
      type: Array,
      default: () => {
        return [
          {
            storeList: [
              {
                title: '台北店',
                storeType: 'home'
              }
            ],
            head: [
              {
                title: '',
                titleClass: '',
                text: '迷你犬包套皮毛管理',
                textClass: '',
                class: ''
              },
              {
                title: '使用期限',
                titleClass: '',
                text: '2021/08/25',
                textClass: '',
                class: ''
              },
              {
                title: '剩餘抵用次數',
                titleClass: '',
                text: '剩餘抵用次數：99+/99+',
                textClass: '',
                class: ''
              }
            ],
            body: [
              {
                title: '',
                titleClass: '',
                text: '台北店',
                textClass: '',
                class: '',
              },
              {
                title: '訂單狀態',
                titleClass: '',
                text: '已取消',
                textClass: '',
                class: '',
              },
              {
                title: '總計',
                titleClass: '',
                text: 'NT$ 800',
                textClass: '',
                class: '',
              },
              {
                title: '訂單成立日期：',
                titleClass: '',
                text: '2021/07/10',
                textClass: '',
                class: '',
              },
            ],
            addOrder: [
              {
                "id": "963f4023-a0e4-420e-9cb5-902e01abefd5",
                "orderNo": "JTAIL2107230001DQU0EADD3F",
                "parentId": "95e92570-fd84-4da9-9534-f641508bc0c6",
                "status": 0,
                "fullName": "測試員",
                "total": 200,
                "payTotal": 0,
                "unpaidTotal": 0,
                "paymentMethod": "Cash",
                "paymentExpiredDate": null,
                "createdDate": "2021-08-06 13:49:14",
                "paidDate": "2021-08-17 14:20:21",
                "cancelDate": "2021-08-06 13:49:55",
                "addItems": [
                  {
                    "title": "精油按摩",
                    "status": 0,
                    "basePrice": 200,
                    "price": 200,
                    "total": 200,
                    "store": {
                      "title": "台北店"
                    }
                  },
                  {
                    "title": "精油按摩",
                    "status": 0,
                    "basePrice": 200,
                    "price": 200,
                    "total": 200,
                    "store": {
                      "title": "台北店"
                    }
                  }
                ]
              },
              {
                "id": "e84e6c28-2332-4caf-8de6-3b6b539df051",
                "orderNo": "JTAIL2107230001DQU0EADDAM",
                "parentId": "95e92570-fd84-4da9-9534-f641508bc0c6",
                "status": 0,
                "fullName": "測試員",
                "total": 500,
                "payTotal": 0,
                "unpaidTotal": 0,
                "paymentMethod": null,
                "paymentExpiredDate": "2021-07-23 16:15:00",
                "createdDate": "2021-08-06 13:50:15",
                "paidDate": null,
                "cancelDate": "2021-08-07 13:50:29",
                "addItems": [
                  {
                    "title": "剪指甲",
                    "status": 0,
                    "basePrice": 500,
                    "price": 500,
                    "total": 500,
                    "store": {
                      "title": "台北店"
                    }
                  }
                ]
              },
              {
                "id": "471ede85-4d1f-4689-857f-056347aee79c",
                "orderNo": "JTAIL2107230001DQU0EADDNA",
                "parentId": "95e92570-fd84-4da9-9534-f641508bc0c6",
                "status": 0,
                "fullName": "測試員",
                "total": 800,
                "payTotal": 0,
                "unpaidTotal": 0,
                "paymentMethod": null,
                "paymentExpiredDate": "2021-07-23 16:30:00",
                "createdDate": "2021-08-06 13:50:48",
                "paidDate": null,
                "cancelDate": "2021-08-06 13:51:00",
                "addItems": [
                  {
                    "title": "剪毛",
                    "status": 0,
                    "basePrice": 800,
                    "price": 800,
                    "total": 800,
                    "store": {
                      "title": "台北店"
                    }
                  }
                ]
              },
              {
                "id": "f7d70707-3b38-47e8-ab35-12c2065db1e8",
                "orderNo": "JTAIL2107230001DQU0EADDUP",
                "parentId": "95e92570-fd84-4da9-9534-f641508bc0c6",
                "status": 0,
                "fullName": "測試員",
                "total": 200,
                "payTotal": 0,
                "unpaidTotal": 0,
                "paymentMethod": "Cash",
                "paymentExpiredDate": null,
                "createdDate": "2021-08-06 13:56:07",
                "paidDate": "2021-08-17 14:20:21",
                "cancelDate": "2021-08-06 13:56:16",
                "addItems": [
                  {
                    "title": "精油按摩",
                    "status": 0,
                    "basePrice": 200,
                    "price": 200,
                    "total": 200,
                    "store": {
                      "title": "台北店"
                    }
                  }
                ]
              }
            ],
            foot: [
              {
                type: 'button',
                text: '預約',
                class: 'flex-grow-1',
                buttonClass: 'isStylePrimary isOutline3 isRadius isSmall isFull',
                onClick: () => {

                },
              },
              {
                type: 'dropdown',
                text: '更多',
                class: 'flex-grow-1',
                buttonClass: 'isStylePrimary isOutline3 isRadius isSmall isFull',
                dropdown: [
                  {
                    text: '前往付款',
                    class: '',
                    onClick: () => {

                    },
                  },
                  {
                    text: '查看訂單',
                    class: '',
                    onClick: () => {

                    },
                  },
                  {
                    text: '再次購買',
                    class: '',
                    onClick: () => {

                    },
                  },
                  {
                    text: '聯繫我們',
                    class: '',
                    onClick: () => {

                    },
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
</script>
<!-- section template -->
<template>
  <ul
    v-loading="loading"
    :element-loading-text="loadingText"
    :class="$style.baseOrderList"
  >
    <li
      v-for="(orderItem, index) in orderList"
      :key="index"
      class="baseOrderList__item"
    >
      <div
        v-if="orderItem.head && !!orderItem.head[0]"
        class="baseOrderList__head"
      >
        <BaseStoreTagList
          v-if="orderItem.storeList && orderItem.storeList[0]"
          :store-list="orderItem.storeList"
        />
        <ul :class="$style.headList">
          <li
            v-for="(headItem, index2) in orderItem.head"
            :key="`headList-${index2}`"
            class="headList__item"
            :class="headItem.class"
          >
            <span
              v-if="!!headItem.title"
              class="headList__title"
              :class="headItem.titleClass"
              v-html="headItem.title"></span>
            <span
              v-if="!!headItem.text"
              class="headList__text"
              :class="headItem.textClass"
              v-html="headItem.text"></span>
          </li>
        </ul>
      </div>
      <div
        v-if="orderItem.body && !!orderItem.body[0]"
        class="baseOrderList__body"
      >
        <ul :class="$style.bodyList">
          <li
            v-for="(bodyItem, index2) in orderItem.body"
            :key="`bodyList-${index2}`"
            class="bodyList__item"
            :class="bodyItem.class"
          >
            <span
              v-if="!!bodyItem.title"
              class="bodyList__title"
              :class="bodyItem.titleClass"
              v-html="bodyItem.title"></span>
            <span
              v-if="!!bodyItem.text"
              class="bodyList__text"
              :class="bodyItem.textClass"
              v-html="bodyItem.text"></span>
          </li>
        </ul>
      </div>
      <div
        v-if="orderItem.addOrder && !!orderItem.addOrder[0]"
        class="baseOrderList__addOrder"
      >
        <BaseOrderListAddOrderToggle
          :add-order-list="orderItem.addOrder"
        />
      </div>
      <div
        v-if="orderItem.foot && !!orderItem.foot[0]"
        class="baseOrderList__foot"
      >
        <ul :class="$style.footList">
          <li
            v-for="(footItem, index2) in orderItem.foot"
            :key="`footList-${index2}`"
            class="footList__item"
            :class="footItem.class"
          >
            <template v-if="!footItem.type || footItem.type === 'button'">
              <BaseButton
                :class="footItem.buttonClass"
                @click="footItem.onClick()"
              >
                <span v-html="footItem.text"></span>
              </BaseButton>
            </template>
            <template v-if="footItem.type === 'dropdown'">
              <el-dropdown :hide-on-click="false" placement="bottom-start" class="w-100">
                <BaseButton
                  :class="footItem.buttonClass"
                  @click.stop.prevent
                >
                  <span v-html="footItem.text"></span>
                </BaseButton>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(dropdownItem, index3) in footItem.dropdown"
                    :key="`dropdownItem-${index3}`"
                    :class="dropdownItem.class"
                    @click.native="dropdownItem.onClick()"
                  >
                    <span v-html="dropdownItem.text"></span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>
<!-- section style -->
<style lang="scss" module>
.baseOrderList {
  @include list-unstyled;

  :global {
    .baseOrderList {
      &__item {
        padding-bottom: 1.5rem;
        margin-bottom: 1.8rem;
        border-bottom: $color-line 1px solid;
      }

      &__head {
        padding: 1.2rem 1.5rem;
        line-height: 1.75;
        color: $color-primary-dark;
        background-color: rgba($color-primary, 0.1);
      }

      &__body {
        padding: 1rem 1.5rem;
        margin-bottom: 0;
        font-size: 0.875rem;
        line-height: 1.75;
      }

      &__addOrder {
        @include unstyled;
      }

      &__foot {
        @include unstyled;
      }
    }
  }
}

.headList {
  @include list-unstyled;

  :global {
    .headList {
      &__item {
        @include unstyled;
      }

      &__title {
        &::after {
          content: ':';
        }
      }

      &__text {
        @include unstyled;
      }
    }
  }
}

.bodyList {
  @include list-unstyled;
  position: relative;

  :global {
    .bodyList {
      &__item {
        @include unstyled;
      }

      &__title {
        &::after {
          content: '：';
        }
      }

      &__text {
        @include unstyled;
      }
    }
  }
}

.footList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  margin: 0 -0.5rem;

  :global {
    .footList {
      &__item {
        padding: 0 0.5rem;
      }

      &__title {
        @include unstyled;
      }

      &__text {
        @include unstyled;
      }
    }
  }
}
</style>
